// src/utils/studentRouting.js
// Helper function to route students based on whether they have courses or not

import { getApiUrl } from './api';

export const routeStudent = async (navigate) => {
  // Check if user is actually a student from sessionStorage
  const storedUser = sessionStorage.getItem('user');
  if (storedUser) {
    try {
      const user = JSON.parse(storedUser);
      if (user.role !== 'student') {
      }
    } catch (error) {
    }
  }

  try {
    const response = await fetch(getApiUrl("/api/course/get"), {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({}),
    });

    if (!response.ok) {
      console.error("❌ Course fetch failed with status:", response.status);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    
    // Handle both new format {status: "success", courses: [...]} and old format {courses: [...]}
    let courseList = [];
    if (data.status === "success" && data.courses) {
      courseList = data.courses;
    } else if (data.courses) {
      // Old format compatibility
      courseList = data.courses;
    } else {
      courseList = [];
    }

    // If student has courses, navigate to the first course's chat page
    if (courseList.length > 0) {
      const firstCourse = courseList[0];
      navigate(`/sessions/${firstCourse.course_number}/${firstCourse.course_name}`);
    } else {
      // If no courses, navigate to student dashboard
      navigate('/student');
    }
  } catch (error) {
    console.error("💥 Error in routeStudent:", error);
    // On error, default to student dashboard
    navigate('/student');
  }
};
